import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import arEg from "antd/lib/locale/ar_EG";
import SwiperCore, { Pagination, Thumbs, Navigation } from "swiper/core";
import { locale } from "./data/locale";
import ScrollToTop from "./components/ScrollToTop";

// styles
import "./styles/main.scss";

// init swiper core
SwiperCore.use([Pagination, Navigation, Thumbs]);

if (locale) document.documentElement.setAttribute("lang", locale);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <ConfigProvider
        locale={locale === "en" ? undefined : arEg}
        direction={locale === "en" ? undefined : "rtl"}
      >
        <ScrollToTop />
        <App />
      </ConfigProvider>
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
